import { Component, OnInit } from '@angular/core';
import { SpinnerService } from 'src/app/services/spinner.service';
import { JobService } from 'src/app/services/job.service';
import { ActivatedRoute } from '@angular/router';
import { JobStatus, SourceType, JobSortType } from 'src/app/common';

@Component({
  templateUrl: './verify-ads.component.html',
  styleUrls: ['./verify-ads.component.scss']
})
export class VerifyAdsComponent implements OnInit {
  JobStatus = JobStatus;
  jobs: any[] = [];
  total: number;
  from = 0;
  limit = 100;

  constructor(private jobService: JobService, private spinner: SpinnerService, private route: ActivatedRoute) { }

  async ngOnInit() {
    await new Promise<void>(resolve => {
      this.route.queryParams.subscribe(async params => {
        this.from = params.from;
        await this.load();
        resolve();
      });
    });
  }

  keyword = '';
  criteria: any;
  async load(payload?: any) {
    this.spinner.show();
    this.from = payload ? payload.from : 0;

    this.criteria = {
      Statuses: [JobStatus.Pending],
      IsExpired: false,
      SourceType: SourceType.Website,
      Sort: JobSortType.ExpirationTime,
      Keyword: this.keyword
    };

    const result = await this.jobService.admin_search(this.criteria, this.from, this.limit);

    this.jobs = result.jobs;
    this.total = result.total;

    this.spinner.hide();
  }

  async rejectAll() {
    await this.jobService.rejectByCriteria(this.criteria);
    delete this.keyword;
    await this.load();
  }

  async setStatus(id: string, status: JobStatus, i?: number, event?: MouseEvent) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    var data = { State: this.jobs[i].State, City: this.jobs[i].City };
    this.jobs.splice(i, 1);
    let process = (status == JobStatus.Started);
    await this.jobService.setStatusByAdmin(id, status, data, process);
    if (!this.jobs.length) {
      await this.load(this.total > this.limit ? this.from : '');
    }
  }

  trackByFn(index: any, item: any) { return item.Id; }

}
